import React from 'react';
import styles from "./Dialog.module.css";
import Btn from '../Btn/Btn';
export interface DialogProps {
  open: boolean;
  type: 'error' | 'success' | 'info' | 'confirm';
  title?: string;
  message: string;
  onClose: (result: boolean) => void;
}
/** hiển thị dialog */
export default function Dialog({ open, type, title, message, onClose }: DialogProps) {
  if (!open) return null;

  let icon = null;
  if (type === 'error') {
    icon = <svg width="48" height="48" viewBox="0 0 48 48"><circle cx="24" cy="24" r="22" stroke="#ff3b30" strokeWidth="4"/><path d="M16 16l16 16M32 16L16 32" stroke="#ff3b30" strokeWidth="4" strokeLinecap="round"/></svg>;
  } else if (type === 'success') {
    icon = <svg width="48" height="48" viewBox="0 0 48 48"><circle cx="24" cy="24" r="22" stroke="#4caf50" strokeWidth="4"/><path d="M14 25l7 7 13-13" stroke="#4caf50" strokeWidth="4" strokeLinecap="round" strokeLinejoin="round"/></svg>;
  } else if (type === 'info') {
    icon = <svg width="48" height="48" viewBox="0 0 48 48"><circle cx="24" cy="24" r="22" stroke="#2196f3" strokeWidth="4"/><circle cx="24" cy="16" r="2.5" fill="#2196f3"/><rect x="22" y="21" width="4" height="13" rx="2" fill="#2196f3"/></svg>;
  }

  return (
    <div className={styles["dialog-overlay"] + " " + styles["dialog-overlay-fade-in"]}>
      <div className={styles["dialog-box"] + " " + styles["dialog-fade-in"]}>
        {(type === 'error' || type === 'success' || type === 'info') && (
          <div style={{ marginBottom: 12 }}>{icon}</div>
        )}
        {type === 'confirm' && (
          <div className="text-large" style={{ fontWeight: 'bold', marginBottom: 10, textAlign: 'center' }}>{title}</div>
        )}
        <div className="text" style={{ textAlign: 'center', marginBottom: 16 }}>{message}</div>
        {(type === 'error' || type === 'success' || type === 'info') && (
          <Btn className="dialog-ok-btn btn-danger" onClick={() => onClose(true)}>OK</Btn>
        )}
        {type === 'confirm' && (
          <div style={{ display: 'flex', gap: 12, justifyContent: 'center' }}>
            <Btn className="dialog-cancel-btn btn-danger text-large" onClick={() => onClose(false)}>Huỷ</Btn>
            <Btn className="dialog-ok-btn btn-danger text-large" onClick={() => onClose(true)}>OK</Btn>
          </div>
        )}
      </div>
    </div>
  );
}